import React from 'react';
import { useTranslation } from 'Components/Helpers/translate';

type HtmlElement = {
	id: number;
	type: string;
	value: { html: string };
};

type Props = {
	element: HtmlElement;
	onChange: (element: HtmlElement) => void;
};

const HtmlContentType = ({ element, onChange }: Props) => {
	const { t } = useTranslation();

	const htmlChanged = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		onChange({ ...element, value: { html: e.target.value } });
	};

	return (
		<div className="tool-main-section">
			<div className="tool-section" key="html-row">
				<label className="tool-label block-label">{t('landingpage.customHtml')}</label>
				<p className="text-dark-grey">
					<i>{t('landingpage.customHtmlInfo')}</i>
				</p>
				<textarea
					className="form-control"
					style={{ minHeight: '200px', fontFamily: 'monospace' }}
					value={element.value.html}
					onChange={htmlChanged}
					placeholder={t('landingpage.enterHtmlHere')}
				/>
			</div>
		</div>
	);
};

export default HtmlContentType;
